import { useScrollTrigger } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { APP_LAYOUT_CONTENT_SELECTOR } from '../../../lib/Scroll';
import { getNumericSpacing } from '../../../lib/Styles';

function useContentScroll(threshold: number, useFirstLayoutContent = false) {
  const theme = useTheme();

  /**
   * Getting all available app layout contents. There could be multiple at the
   * same time in the room creation/preview scenarios, because they wrap a smaller
   * app layout content in order to display the room edition or preview.
   */
  const scrollTargets = document.querySelectorAll(APP_LAYOUT_CONTENT_SELECTOR);
  /**
   * Trying to use the second-to-last node of the app layout content, just for
   * the room preview scenario, where there are a total of 4 app layout contents.
   * This is necessary because neither the first one or the last one have a
   * scroll that would trigger the scroll behavior.
   *
   * @warning make sure to test scrolling in the room create/edit -> preview room,
   * if you change the scroll target
   */
  let scrollTarget = scrollTargets[0];
  if (!useFirstLayoutContent) {
    scrollTarget =
      scrollTargets.length === 2
        ? scrollTargets[1]
        : scrollTargets[scrollTargets.length - 2] || scrollTargets[0];
  }

  const isContentScrolling = useScrollTrigger({
    disableHysteresis: true,
    target: (scrollTarget as Node) ?? undefined,
    // 38px of padding + margin that's before the first room content
    threshold: threshold + getNumericSpacing(theme, 4.75),
  });

  return isContentScrolling;
}

export default useContentScroll;
